import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

import useAuth from '@/composables/useAuth';

export default function useTeamTable() {
  const { currentUser, hasScope } = useAuth();
  const canEditUsers = computed(() => hasScope('write:members'));
  /* Row selection */
  /* Using AG Grid's native row selection does not work because the table is re-rendered when the search is applied.
Instead each row has an "isChecked" property that is used to render a checkbox as checked or not, and
calls the handlePickUser callback to set this state in the parent */
  const selectedUserIds = ref<Set<number | undefined>>(new Set([]));
  const singleSelectedUserId = computed(() =>
    selectedUserIds.value.size === 1
      ? selectedUserIds.value.values().next().value
      : null,
  );
  const selectedCount = computed(() => selectedUserIds.value.size);

  /* Deletes */
  const isSelfSelected = computed(() =>
    selectedUserIds.value.has(currentUser.value.id as never),
  );
  const deleteDisabled = computed(
    () => isSelfSelected.value || !canEditUsers.value,
  );

  const router = useRouter();
  async function handleEdit() {
    if (singleSelectedUserId.value)
      await router.push({
        name: 'edit_user',
        params: { user_id: singleSelectedUserId.value },
      });
    else
      await router.push({
        name: 'edit_users',
        query: { ids: [...selectedUserIds.value] },
      });
  }

  async function handleDelete() {
    if (singleSelectedUserId.value)
      await router.push({
        name: 'remove_user',
        params: { user_id: singleSelectedUserId.value },
      });
    else
      await router.push({
        name: 'remove_users',
        query: { ids: [...selectedUserIds.value] },
      });
  }
  return {
    canEditUsers,
    deleteDisabled,
    handleDelete,
    handleEdit,
    selectedCount,
    selectedUserIds,
  };
}
